import { Rule } from '@idm/react-forms';

// AIM rule: 4+ consecutive sequential characters (forward or backward) are invalid.
// "abcd" and "4321" are invalid; "abc" and "321" are valid.
class NoSequentialCharRule extends Rule {
  validate(value) {
    for (let i = 0; i <= value.length - 4; i += 1) {
      const a = value.charCodeAt(i);
      const b = value.charCodeAt(i + 1);
      const c = value.charCodeAt(i + 2);
      const d = value.charCodeAt(i + 3);

      if (b === a + 1 && c === a + 2 && d === a + 3) {
        throw new Error('Password contains 4 or more sequential characters');
      }
      if (b === a - 1 && c === a - 2 && d === a - 3) {
        throw new Error('Password contains 4 or more reverse sequential characters');
      }
    }
  }

  static get ruleName() {
    return 'no-sequential-chars';
  }

  getDefaultMessage() {
    return 'No more than 3 sequential characters';
  }
}

export default NoSequentialCharRule;
